module.exports = "<editor *ngIf=\"form\"\n[disabled] = \"disable\"\n[(ngModel)]=\"texto\"\n[formControl]=\"formControlName\"\n[init]=\"init\"\n></editor>\n<editor *ngIf=\"form==null\"\n[disabled] = \"true\"\n[(ngModel)]=\"texto\"\n[init]=\"init\"\n></editor>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/tinymce-editor/tinymce-editor.component.html
// module id = ./src/app/shared/tinymce-editor/tinymce-editor.component.html
// module chunks = main